exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox-div .v-input--selection-controls {\n  margin-top: 0px;\n  padding-top: 0px;\n}\n", ""]);

// exports
